import Vue from 'vue'
import Router from 'vue-router'
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return routerPush.call(this, location).catch(error => error)
}
import index from '@/page/index'
import order from '@/page/order'

Vue.use(Router);
export default new Router({
    routes: [
        {
            path: '/',
            name: '',
            component: index,
            meta: {
                title: '首页'
            }
        },
        {
            path: '/index',
            name: 'index',
            component: index,
            meta: {
                title: '首页'
            }
        },
        {
            path: '/order',
            name: 'order',
            component: order,
            meta: {
                title: '任务审核'
            }
        },
    ]
})



